module.exports = __webpack_public_path__ + "static/img/probject_ptz.7e14ee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/probject_ptz.jpg
// module id = Ce+K
// module chunks = 1